import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, ChevronRightRounded, ExpandLessRounded, InsertLinkOutlined } from "@mui/icons-material";
import { Typography } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiStack } from "../../../components";
import StatusColor from "../../../components/atoms/statusColor";
import { LOCAL_STORAGE_KEYS } from "../../../constants";
import { showNotification } from "../../../redux/commonSlice";
import { useAppSelector } from "../../../store/hooks";
import { faintblue } from "../../../theme/palette";
import { systemColor } from "../../../theme/systemColor";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { dateFormate } from "../../../utils/utils";
import BranchToBranchRequisitionPartDetails from "../components/branchToBranchRequisitionPartDetails";
import { branchListGet, branchToBranchRequisitionAttachmentDelete, branchToBranchRequisitionCreate, getBranchToBranchRequisition, priorityListGet, uploadBranchToBranchRequisitionAttachment, warehouseListGet } from "../services/apiCalls";
import { BranchToBranchRequisitionAPIKeys } from "../services/entity";
export var CreateBranchToBranchRequisition = function () {
    var _getLocalStorageItem, _crud$BranchToBranchR, _crud$profilePersonal3, _crud$profilePersonal4, _crud$profilePersonal5, _crud$profilePersonal6, _crud$profilePersonal7, _crud$profilePersonal8, _crud$profilePersonal9, _crud$profilePersonal10;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useState(), grandTotal = _a[0], setGrandTotal = _a[1];
    var crud = useAppSelector(function (state) { return state.crud; });
    var id = useParams().id;
    var searchParams = useSearchParams()[0];
    var mode = searchParams.get('mode');
    var branchToBranchRequisitionGetById = useAppSelector(function (state) { return state.crud; }).branchToBranchRequisitionGetById;
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var data = (_crud$BranchToBranchR = crud[BranchToBranchRequisitionAPIKeys.get]) === null || _crud$BranchToBranchR === void 0 ? void 0 : _crud$BranchToBranchR.data;
    var isDisable = (data === null || data === void 0 ? void 0 : data.Status.Key) === 'Completed' ? true : false;
    var branchList = function (params) {
        var _crud$profilePersonal;
        return branchListGet(_objectSpread(_objectSpread({}, params), {}, {
            request: _objectSpread(_objectSpread({}, params.request), {}, {
                ParentOrganizationId: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.Branches[0]) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.ParentOrganizationId
            })
        }));
    };
    var warehouseList = function (params) {
        var _crud$profilePersonal2;
        return warehouseListGet(_objectSpread(_objectSpread({}, params), {}, {
            request: _objectSpread(_objectSpread({}, params.request), {}, {
                TenantId: crud === null || crud === void 0 || (_crud$profilePersonal2 = crud.profilePersonalDetails) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.data) === null || _crud$profilePersonal2 === void 0 || (_crud$profilePersonal2 = _crud$profilePersonal2.Branches[0]) === null || _crud$profilePersonal2 === void 0 ? void 0 : _crud$profilePersonal2.OrganizationId
            })
        }));
    };
    var handleClickGrandTotal = function (event) { };
    var generalDetailsForm = [{
            type: FormItemTypes.CardComponent,
            name: '',
            label: '',
            value: null,
            columnSize: 12,
            variant: 'outlined',
            title: 'Basic Details',
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: "SourceTenantId",
                    label: "Source branch",
                    value: null,
                    required: true,
                    getListData: branchList,
                    disabled: isDisable
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: "DestinationTenantId",
                    label: "Destination branch",
                    value: null,
                    getListData: branchList,
                    disabled: isDisable,
                    setFormState: function (value, currValue) {
                        if ((value === null || value === void 0 ? void 0 : value.SourceTenantId) === (currValue === null || currValue === void 0 ? void 0 : currValue.id)) {
                            dispatch(showNotification({
                                isOpen: true,
                                message: "Source Branch and Destination Branch cannot be the same",
                                type: "error"
                            }));
                            return null;
                        }
                        return currValue;
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'SourceWarehouseId',
                    label: 'Warehouse',
                    getListData: warehouseList,
                    required: true,
                    disabled: isDisable,
                    valueExpr: "id",
                    displayExpr: "Name",
                    setFormState: function (value, currValue) {
                        return {
                            DestinationWarehouseId: currValue === null || currValue === void 0 ? void 0 : currValue.id
                        };
                    }
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PriorityId',
                    label: 'Priority',
                    getListData: priorityListGet,
                    value: null,
                    setFormState: function (formValues, currValue) {
                        return {
                            Priority: currValue
                        };
                    },
                    disabled: isDisable
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'PriorityRemarks',
                    label: "Priority reason (0/150 characters)",
                    value: null,
                    placeholder: "Enter Priority reason",
                    maxLength: 150,
                    multiline: true,
                    minRows: 2,
                    disabled: isDisable,
                    setFieldProps: function (formValues, value) {
                        var _formValues$Priority, _formValues$Priority2, _value$length;
                        return {
                            type: this.type,
                            containerProps: {
                                display: (formValues === null || formValues === void 0 || (_formValues$Priority = formValues.Priority) === null || _formValues$Priority === void 0 ? void 0 : _formValues$Priority.Name) !== 'High' ? 'none' : 'unset'
                            },
                            required: (formValues === null || formValues === void 0 || (_formValues$Priority2 = formValues.Priority) === null || _formValues$Priority2 === void 0 ? void 0 : _formValues$Priority2.Name) === 'High',
                            label: "Priority reason (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/150 characters)")
                        };
                    }
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ScheduleTransportDate",
                    label: "Schedule for transport date",
                    value: null,
                    disabled: isDisable
                }]
        }];
    var additionalDetailsForm = [{
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            title: '',
            elements: [{
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedTransferDate",
                    label: "Expected transfer date",
                    disabled: isDisable
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedPickupDate",
                    label: "Expected pickup date",
                    value: null,
                    disabled: isDisable
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "ExpectedDeliveryDate",
                    label: "Expected delivery date",
                    value: null,
                    disabled: isDisable
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "DispatchDate",
                    label: "Dispatch date",
                    value: null,
                    disabled: true
                }, {
                    type: FormItemTypes.DatePicker,
                    name: "DeliveryDate",
                    label: "Delivery date",
                    value: null,
                    disabled: true
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: 'Notes & attachments',
                    label: 'Notes & attachments',
                    value: null,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'Remarks',
                            label: 'Transfer reasons (0/200 characters)',
                            placeholder: 'Enter reasons',
                            value: null,
                            md: 6,
                            multiline: true,
                            minRows: 2,
                            labelTypographyProps: {
                                variant: 'h6',
                                color: '#8593A3'
                            },
                            disabled: isDisable
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'Attachments',
                            label: 'Add attachments',
                            placeholder: 'Upload Files',
                            disabled: isDisable,
                            value: null,
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            },
                            uploadAttachmentRequest: {
                                systemname: BranchToBranchRequisitionAPIKeys.AttachmentSystemName
                            },
                            uploadAttachmentAPI: uploadBranchToBranchRequisitionAttachment,
                            deleteAttachmentAPI: branchToBranchRequisitionAttachmentDelete
                        }]
                }]
        }];
    var partDetails = [{
            type: FormItemTypes.Custom,
            name: "StockTransferRequisitionDetail",
            element: BranchToBranchRequisitionPartDetails,
            columnSize: 12,
            disabled: isDisable
        }, {
            type: FormItemTypes.CardComponent,
            name: "",
            columnSize: 12,
            variant: "outlined",
            containerProps: {
                alignContent: "flex-end"
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: 'flex-end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "GrandTotal",
                            label: "",
                            value: null,
                            md: 4,
                            children: /*#__PURE__*/ React.createElement(Typography, {
                                sx: {
                                    flexGrow: 1
                                },
                                fontWeight: "bold",
                                textAlign: "left"
                            }, "Grand Total"),
                            variant: "outlined",
                            fullWidth: true,
                            valueGetter: function (formValues, currValue) {
                                var _formValues$PurchaseO;
                                var totalSum = formValues === null || formValues === void 0 || (_formValues$PurchaseO = formValues.PurchaseOrderDetails) === null || _formValues$PurchaseO === void 0 ? void 0 : _formValues$PurchaseO.reduce(function (acc, data) {
                                    return acc + data.ModifiedQuantity * data.Rate;
                                }, 0);
                                setGrandTotal(totalSum && totalSum);
                                return totalSum;
                            },
                            sx: {
                                justifyContent: "space-between",
                                bgcolor: "rgba(0,0,0,0.05)",
                                fontWeight: "bold",
                                color: systemColor.secondary
                            },
                            endIcon: grandTotal ? "? ".concat(grandTotal) : "? 00.00",
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: this.type,
                                    startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ExpandLessRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null)
                                };
                            },
                            setFormState: function (formValues, e, field) {
                                return {
                                    Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                                };
                            },
                            onClick: function (e, value) { return handleClickGrandTotal(e); }
                        }]
                }]
        }];
    var tabs = [{
            id: "0",
            label: "General",
            elements: generalDetailsForm
        }, {
            id: "1",
            label: "Part details",
            elements: partDetails
        }, {
            id: "2",
            label: "Additional information",
            elements: additionalDetailsForm
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            columnSpacing: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        onClick: function () { return navigate("/branchToBranchRequisition"); }
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: "",
                    children: id ? "Edit branch to branch requisition" : "New branch to branch requisition",
                    columnSize: 0,
                    variant: "h1",
                    noWrap: true
                }, {
                    type: FormItemTypes.Custom,
                    name: "",
                    columnSize: 0,
                    element: function () {
                        var _branchToBranchRequis, _branchToBranchRequis2;
                        return id ? /*#__PURE__*/ React.createElement(MuiStack, {
                            sx: {
                                border: "1px solid #DEE4EB",
                                borderRadius: "6px",
                                gap: "5px",
                                padding: "3px 8px"
                            },
                            alignItems: "center"
                        }, /*#__PURE__*/ React.createElement(StatusColor, {
                            status: branchToBranchRequisitionGetById === null || branchToBranchRequisitionGetById === void 0 || (_branchToBranchRequis = branchToBranchRequisitionGetById.data) === null || _branchToBranchRequis === void 0 || (_branchToBranchRequis = _branchToBranchRequis.Status) === null || _branchToBranchRequis === void 0 ? void 0 : _branchToBranchRequis.Name
                        }), /*#__PURE__*/ React.createElement(Typography, {
                            id: "statusKeyId",
                            variant: "h6"
                        }, branchToBranchRequisitionGetById === null || branchToBranchRequisitionGetById === void 0 || (_branchToBranchRequis2 = branchToBranchRequisitionGetById.data) === null || _branchToBranchRequis2 === void 0 || (_branchToBranchRequis2 = _branchToBranchRequis2.Status) === null || _branchToBranchRequis2 === void 0 ? void 0 : _branchToBranchRequis2.Name)) : /*#__PURE__*/ React.createElement(React.Fragment, null);
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 0,
                    elements: mode !== "edit" ? [] : [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentCode',
                            label: 'DOC NUMBER: ',
                            value: null,
                            columnSize: 0,
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'CreatedOn',
                            label: 'DOC DATE: ',
                            value: null,
                            valueGetter: function (formData) {
                                return dateFormate(formData === null || formData === void 0 ? void 0 : formData.CreatedOn);
                            },
                            columnSize: 0,
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 12
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Quick Links',
                            disabled: true,
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            height: '100%',
                            width: '2px',
                            bgcolor: 'rgba(0,0,0,0.1)',
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            disabled: isDisable,
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: 'Stepper',
            tabs: tabs,
            valueExpr: 'id',
            displayExpr: 'label',
            columnSize: 12,
            variant: 'scrollable',
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: 'Save',
                    children: 'Save',
                    id: 'save',
                    columnSize: 0,
                    variant: 'contained',
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    var handleOnFormClose = function () {
        if (mode == "add") {
            dispatch(showNotification({
                isOpen: true,
                message: "Branch To Branch Requisition Created Successfully",
                type: "success"
            }));
        }
        else {
            dispatch(showNotification({
                isOpen: true,
                message: "Branch To Branch Requisition Updated Successfully",
                type: "success"
            }));
        }
        navigate("/branchToBranchRequisition");
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 2,
        formProps: {
            bgcolor: faintblue
        },
        getFormAPI: getBranchToBranchRequisition,
        getKey: BranchToBranchRequisitionAPIKeys.get,
        getRequest: {
            id: id
        },
        pagingAPIKey: BranchToBranchRequisitionAPIKeys.paging,
        createKey: BranchToBranchRequisitionAPIKeys.create,
        createFormAPI: branchToBranchRequisitionCreate,
        createRequest: {
            AssignTo: crud === null || crud === void 0 || (_crud$profilePersonal3 = crud.profilePersonalDetails) === null || _crud$profilePersonal3 === void 0 || (_crud$profilePersonal3 = _crud$profilePersonal3.data) === null || _crud$profilePersonal3 === void 0 ? void 0 : _crud$profilePersonal3.IdentityId,
            SourceParentTenantId: crud === null || crud === void 0 || (_crud$profilePersonal4 = crud.profilePersonalDetails) === null || _crud$profilePersonal4 === void 0 || (_crud$profilePersonal4 = _crud$profilePersonal4.data) === null || _crud$profilePersonal4 === void 0 || (_crud$profilePersonal4 = _crud$profilePersonal4.Branches[0]) === null || _crud$profilePersonal4 === void 0 ? void 0 : _crud$profilePersonal4.ParentOrganizationId,
            DestinationParentTenantId: crud === null || crud === void 0 || (_crud$profilePersonal5 = crud.profilePersonalDetails) === null || _crud$profilePersonal5 === void 0 || (_crud$profilePersonal5 = _crud$profilePersonal5.data) === null || _crud$profilePersonal5 === void 0 || (_crud$profilePersonal5 = _crud$profilePersonal5.Branches[0]) === null || _crud$profilePersonal5 === void 0 ? void 0 : _crud$profilePersonal5.ParentOrganizationId,
            TotalQuantity: 0,
            TotalAmount: 0,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal6 = crud.profilePersonalDetails) === null || _crud$profilePersonal6 === void 0 || (_crud$profilePersonal6 = _crud$profilePersonal6.data) === null || _crud$profilePersonal6 === void 0 ? void 0 : _crud$profilePersonal6.IdentityId,
            DocumentDate: new Date().toISOString(),
            RejectRemarks: "NA",
            Type: "BToBRequisition",
            Status: "Draft"
        },
        updateRequest: {
            AssignTo: crud === null || crud === void 0 || (_crud$profilePersonal7 = crud.profilePersonalDetails) === null || _crud$profilePersonal7 === void 0 || (_crud$profilePersonal7 = _crud$profilePersonal7.data) === null || _crud$profilePersonal7 === void 0 ? void 0 : _crud$profilePersonal7.IdentityId,
            SourceParentTenantId: crud === null || crud === void 0 || (_crud$profilePersonal8 = crud.profilePersonalDetails) === null || _crud$profilePersonal8 === void 0 || (_crud$profilePersonal8 = _crud$profilePersonal8.data) === null || _crud$profilePersonal8 === void 0 || (_crud$profilePersonal8 = _crud$profilePersonal8.Branches[0]) === null || _crud$profilePersonal8 === void 0 ? void 0 : _crud$profilePersonal8.ParentOrganizationId,
            DestinationParentTenantId: crud === null || crud === void 0 || (_crud$profilePersonal9 = crud.profilePersonalDetails) === null || _crud$profilePersonal9 === void 0 || (_crud$profilePersonal9 = _crud$profilePersonal9.data) === null || _crud$profilePersonal9 === void 0 || (_crud$profilePersonal9 = _crud$profilePersonal9.Branches[0]) === null || _crud$profilePersonal9 === void 0 ? void 0 : _crud$profilePersonal9.ParentOrganizationId,
            TotalQuantity: 0,
            TotalAmount: 0,
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal10 = crud.profilePersonalDetails) === null || _crud$profilePersonal10 === void 0 || (_crud$profilePersonal10 = _crud$profilePersonal10.data) === null || _crud$profilePersonal10 === void 0 ? void 0 : _crud$profilePersonal10.IdentityId,
            RejectRemarks: "NA",
            Type: "BToBRequisition",
            Status: "Draft"
        },
        updateFormAPI: branchToBranchRequisitionCreate,
        updateKey: BranchToBranchRequisitionAPIKeys.update,
        onClose: handleOnFormClose
    }));
};
